import React from 'react';
import withQueries from './withQueries';
import { connect } from 'react-redux';
import {
  setCourtApplication as setCourtApplicationAction,
  clearCourtApplication as clearCourtApplicationAction
} from '../../../actions/courtApplication-actions';
import { showMessage as showMessageAction } from '../../../actions/message-actions';
import TaskCreator from '../../TaskCreator';

const CreateCourtApplication = props => {
  const stages = [
    'pre-section',
    'passengers documents',
    'sections',
    'airRefund attachments',
    'court attachments',
    'summary'
  ];
  return (
    <TaskCreator
      {...props}
      taskType="CA"
      taskTitle="Create Court Application"
      stages={stages}
      documentType="Documents::CourtApplication"
    />
  );
};

const mapStateToProps = ({ courtApplication }) => ({
  taskValues: courtApplication
});

const mapDispatchToProps = dispatch => ({
  setTaskValues: data => dispatch(setCourtApplicationAction(data)),
  clearTaskValues: () => dispatch(clearCourtApplicationAction()),
  showMessage: message => dispatch(showMessageAction(message))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withQueries(CreateCourtApplication));



// WEBPACK FOOTER //
// ./src/component/tasks/CreateCourtApplication/index.js